import { apiFetch } from './apiClient';
import { foodsClient } from '../../../backend/src/client';
import { getDbForCurrentUser } from '@/services/rxdb/database';
import { CUSTOM_FOOD_MIGRATIONS_COLLECTION, type CustomFoodMigration, type CustomFoodMigrationStatus } from '@macro-tracker/models';

export type { CustomFoodMigration, CustomFoodMigrationStatus };
/** @deprecated Use {@link CustomFoodMigration} */
export type CustomFoodMigrationRecord = CustomFoodMigration;
/** @deprecated Use {@link CustomFoodMigration} */
export type SyncableCustomFoodMigrationRecord = CustomFoodMigration;

type ResolveMigrationResponse = {
  migration: CustomFoodMigration;
  updatedDiaryEntryCount: number;
};

const client = foodsClient(apiFetch);

export const getCustomFoodMigrations = async (): Promise<CustomFoodMigration[]> => {
  const db = await getDbForCurrentUser();
  const docs = await db[CUSTOM_FOOD_MIGRATIONS_COLLECTION].find().exec();
  return docs.map((d) => d.toMutableJSON() as CustomFoodMigration);
};

export const getPendingCustomFoodMigrations = async (): Promise<CustomFoodMigration[]> => {
  const db = await getDbForCurrentUser();
  const docs = await db[CUSTOM_FOOD_MIGRATIONS_COLLECTION]
    .find({ selector: { status: 'pending' } }).exec();
  return docs
    .map((d) => d.toMutableJSON() as CustomFoodMigration)
    .sort((a, b) => new Date(a.createdAt).getTime() - new Date(b.createdAt).getTime());
};

export const applyCustomFoodMigration = async (id: string): Promise<ResolveMigrationResponse> => {
  const response = await client['custom-migrations'][':id'].apply.$post({
    param: { id },
  });

  if (!response.ok) {
    const error = await response.json().catch(() => ({ message: 'Failed to apply custom food migration.' }));
    throw new Error(error.message ?? 'Failed to apply custom food migration.');
  }

  return response.json() as Promise<ResolveMigrationResponse>;
};

export const ignoreCustomFoodMigration = async (id: string): Promise<ResolveMigrationResponse> => {
  const response = await client['custom-migrations'][':id'].ignore.$post({
    param: { id },
  });

  if (!response.ok) {
    const error = await response.json().catch(() => ({ message: 'Failed to ignore custom food migration.' }));
    throw new Error(error.message ?? 'Failed to ignore custom food migration.');
  }

  return response.json() as Promise<ResolveMigrationResponse>;
};
